import { render, staticRenderFns } from "./system_auth_group.vue?vue&type=template&id=67f34cf9&scoped=true&"
import script from "./system_auth_group.vue?vue&type=script&lang=js&"
export * from "./system_auth_group.vue?vue&type=script&lang=js&"
import style0 from "./system_auth_group.vue?vue&type=style&index=0&id=67f34cf9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f34cf9",
  null
  
)

export default component.exports